import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'rolename' })
export class RoleNamePipe implements PipeTransform {
    transform(role) {

        let rolename = '';

        switch (role) {
            case 1: // Customer
                rolename = 'Customer';
                break;
            case 2: // Store Owner
                rolename = 'Owner';
                break;
            case 3: // Group User
                rolename = 'Group';
                break;
            case 4: // super admin
                rolename = 'Super Admin';
                break;
            default:
                rolename = '';
        }
        return rolename;
    }
}



// WEBPACK FOOTER //
// ./src/app/_pipes/role.pipe.ts